export const getFileFootprint = (file: File) => {
  return file.name + '-' + file.size + '-' + file.type;
};
